document.addEventListener('DOMContentLoaded', function () {

    const botonesSeleccionar = document.querySelectorAll('.btnSeleccionarPreforma');
    const modalPreforma = document.querySelector('#modalAgregarPreforma');

    if (botonesSeleccionar.length === 0 || !modalPreforma) return;

    const contReferencias = modalPreforma.querySelector('#contReferencias');
    const inputFiltro = modalPreforma.querySelector('#filtroReferencias');

    let tipoRefActual = null;
    let referenciasCargadas = false;

    botonesSeleccionar.forEach(btn => {
        btn.addEventListener('click', function () {
            const origenModalId = this.getAttribute('data-origen') || '';
            const tipoRef = this.getAttribute('data-tipo-ref') || null;

            modalPreforma.dataset.origenModal = origenModalId;

            if (!referenciasCargadas || tipoRef !== tipoRefActual) {
                tipoRefActual = tipoRef;
                referenciasCargadas = false;
                cargarPreformas(tipoRef);
            }

            modalPreforma.classList.add('modal--show');
        });
    });

    if (inputFiltro) {
        inputFiltro.addEventListener('input', function () {
            const termino = this.value.trim().toLowerCase();
            const items = contReferencias.querySelectorAll('.referencia');
            items.forEach(item => {
                const codigo = (item.getAttribute('data-codigo') || '').toLowerCase();
                const ref = (item.getAttribute('data-ref') || '').toLowerCase();
                item.style.display = (!termino || codigo.includes(termino) || ref.includes(termino)) ? '' : 'none';
            });
        });
    }

    async function cargarPreformas(tipoRef) {
        contReferencias.innerHTML = '<p class="cargandoReferencias">Cargando preformas...</p>';

        try {
            const url = tipoRef
                ? `/api/configuracion/referencias/activas?tipo=${encodeURIComponent(tipoRef)}`
                : '/api/configuracion/referencias/activas';

            const respuesta = await fetch(url);
            const json = await respuesta.json();

            if (respuesta.status !== 200 || !json.result) {
                contReferencias.innerHTML = '<p class="no-info">No se pudieron cargar las preformas.</p>';
                return;
            }

            let referencias = json.result;

            // Si no se filtró por tipo-ref, se filtra client-side por tipo "preforma"
            if (!tipoRef) {
                referencias = referencias.filter(ref =>
                    (ref.tipoReferencia || '').toLowerCase().includes('preforma')
                );
            }

            if (!referencias.length) {
                contReferencias.innerHTML = '<p class="no-info">No hay preformas activas disponibles.</p>';
                return;
            }

            contReferencias.innerHTML = referencias.map(ref => `
                <div class="referencia"
                     data-id="${escapeAttr(String(ref.idReferencia))}"
                     data-codigo="${escapeAttr(ref.codigoSap)}"
                     data-ref="${escapeAttr(ref.descripSap)}"
                     data-peso="${escapeAttr(String(ref.peso ?? ''))}">
                    <article class="articuloCard">
                        <div class="articuloCardTitulo">
                            <h3>${escapeHtml(ref.tipoReferencia || 'Preforma')}</h3>
                        </div>
                        <dl class="articuloCardLista">
                            <dt>Codigo:</dt>
                            <dd>${escapeHtml(ref.codigoSap || '')}</dd>
                            <dt>Referencia:</dt>
                            <dd>${escapeHtml(ref.descripSap || '')}</dd>
                            <dt>Peso [Gr]:</dt>
                            <dd>${escapeHtml(String(ref.peso ?? '—'))}</dd>
                        </dl>
                    </article>
                </div>
            `).join('');

            referenciasCargadas = true;

        } catch (error) {
            console.error('Error al cargar preformas:', error);
            contReferencias.innerHTML = '<p class="no-info">Error al cargar las preformas.</p>';
        }
    }

    contReferencias.addEventListener('click', function (e) {
        const item = e.target.closest('.referencia');
        if (!item) return;
        seleccionarPreforma(item);
    });

    function seleccionarPreforma(elemento) {
        const id = elemento.getAttribute('data-id');
        const codigo = elemento.getAttribute('data-codigo');
        const referencia = elemento.getAttribute('data-ref');
        const peso = elemento.getAttribute('data-peso');

        const origenModalId = modalPreforma.dataset.origenModal;
        const modalOrigen = document.querySelector('#' + origenModalId);

        if (!origenModalId || !modalOrigen || !id || !codigo || !referencia) {
            alert('Faltan datos para completar la acción');
            return;
        }

        const inputId = modalOrigen.querySelector('#idPreforma');
        const inputCod = modalOrigen.querySelector('#codPreforma');
        const inputDesc = modalOrigen.querySelector('#descPreforma');
        const inputPeso = modalOrigen.querySelector('#pesoPreforma');

        if (!inputId || !inputCod || !inputDesc) {
            alert('No se encontraron los campos destino de la preforma');
            return;
        }

        inputId.value = id;
        inputCod.value = codigo;
        inputDesc.value = referencia;
        if (inputPeso) inputPeso.value = peso || '';

        modalPreforma.classList.remove('modal--show');
    }

    function escapeHtml(str) {
        return String(str)
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    function escapeAttr(str) {
        return String(str).replace(/"/g, '&quot;');
    }
});
